import { observer } from 'mobx-react-lite';

import { Button } from '@flixbus/honeycomb-react';

import { rideDetailsStore } from 'pages/RideDetails/RideDetailsStore';

import { assignAllText } from './text';

import styles from './styles.module.css';

const AssignAll = observer(() => {
	const isActive = rideDetailsStore.checkAssignAll();
	// "Ungroup all" surfaces only when the whole batch is still unassigned.
	// Once a driver has been picked, the batch is legalized by the assignment
	// and can't be trivially reversed — the ribbon falls back to "Group all".
	const assignments = [...rideDetailsStore.workAssignments.values()];
	const isUnassignedGlobalBatch =
		assignments.length > 0 &&
		assignments.every((wa) => wa?.isGlobalBatched === true && wa?.crewMember == null);

	return (
		<div className={styles.wrapperBatchRibbon}>
			<Button onClick={() => rideDetailsStore.assignAll()} disabled={!isActive}>
				{assignAllText.assignEntirely}
			</Button>
			{isUnassignedGlobalBatch ? (
				<Button onClick={() => rideDetailsStore.resetAssignAll()}>
					{assignAllText.ungroupAll}
				</Button>
			) : (
				<Button onClick={() => rideDetailsStore.groupAll()} disabled={!isActive}>
					{assignAllText.groupAll}
				</Button>
			)}
		</div>
	);
});

export default AssignAll;
